import { UserRoles } from 'entities/User/types';

export const Prefixes = {
	// root prefix
	root: '/',

	// grouping prefixes
	startRecognition: 'start-recognition/',
	customModel: 'model/',
	files: 'files-list',
	importModel: 'import-model/',
	importCustomFilesDirect: 'import-direct-model/',
	importCustomFilesFromFtp: 'import-ftp-model/',
	editFile: 'files/edit-file/',
	editModelFile: 'edit-model-file/',
	coUsers: 'co-users/',
	integrations: 'integrations',
	signUp: 'sign-up/',
	signIn: 'sign-in/',
	forgotPassword: 'forgot-password/',
	createPassword: 'create-password/',
	changeEmail: 'change-email/',
	users: 'users/',
	resources: 'resources/',
	extensions: 'extensions',
	partners: 'partners',
	syncSettings: 'sync-settings',
	signOut: '/sign-out',
};

export const RoutesMap = {
	startRecognition: {
		root: '',
		importFilesDirect: 'import-direct',
		importFilesFromFtp: 'import-ftp',
	},
	customModel: {
		root: 'custom-model',
		importModel: 'import-model/:modelId',
		settings: 'custom-model/settings/:modelId',
	},
	generativeModel: {
		root: 'generative-model',
		upload: '/upload/:generativeModelId',
		fileEditor: '/:generativeModelId/file-editor/:fileId',
		settings: '/settings/:generativeModelId',
	},
	importModel: {
		root: ':modelId',
	},
	files: {
		settings: '/settings',
	},
	editFile: {
		root: ':fileId',
	},
	subscriptions: 'subscriptions',
	extensions: {
		root: '',
		exList: '/list',
		exDetails: ':exName',
	},
	coUsers: {
		root: '',
		details: ':coUserId',
	},
	personalAccount: 'personal-account',
	integrations: {
		// apiSettings: 'api-settings',
		ftpSettings: '/ftp-settings',
		publicApiAccess: '/api-keys',
	},
	support: 'support',

	signUp: {
		root: '',
		emailSent: 'email-sent',
		emailReceived: 'email-received/:token',
		byInvitation: 'by-invitation/:token',
	},
	signIn: {
		root: '',
		removedAccount: 'account-removed',
	},
	forgotPassword: {
		root: '',
		emailSent: 'email-sent',
	},
	createPassword: {
		root: ':token',
		linkExpired: 'link-expired',
		success: 'success',
	},
	changeEmail: {
		root: '',
		emailSent: 'email-sent',
	},
	privacyPolicy: 'privacy-policy',
	playground: 'playground',
	users: {
		root: '',
		details: ':userId',
	},
	resources: 'resources',

	partners: {
		root: '',
		settings: '/settings',
		settingsWithId: '/:partnerId/settings',
		documents: '/documents',
		documentsWithId: '/:partnerId/documents',
	},
};

export const Routes = {
	startRecognition: `${Prefixes.root}${RoutesMap.startRecognition.root}`,
	importFilesDirect: `${Prefixes.root}${Prefixes.startRecognition}${RoutesMap.startRecognition.importFilesDirect}`,
	importFilesFromFtp: `${Prefixes.root}${Prefixes.startRecognition}${RoutesMap.startRecognition.importFilesFromFtp}`,

	customModel: `${Prefixes.root}${RoutesMap.customModel.root}`,
	importCustomFilesRoot: `${Prefixes.root}${RoutesMap.customModel.importModel}`,
	customModelSettings: `${Prefixes.root}${RoutesMap.customModel.settings}`,
	importFilesCustomModel: `${Prefixes.root}${Prefixes.importCustomFilesDirect}${RoutesMap.importModel.root}`,
	importFilesFromFtpCustomModel: `${Prefixes.root}${Prefixes.importCustomFilesFromFtp}${RoutesMap.importModel.root}`,
	editModelFileRoot: `${Prefixes.root}${Prefixes.editModelFile}${RoutesMap.importModel.root}`,

	generativeModel: `${Prefixes.root}${RoutesMap.generativeModel.root}`,
	generativeModelUpload: `${Prefixes.root}${RoutesMap.generativeModel.root}${RoutesMap.generativeModel.upload}`,
	generativeModelFileEditor: `${Prefixes.root}${RoutesMap.generativeModel.root}${RoutesMap.generativeModel.fileEditor}`,
	generativeModelSettings: `${Prefixes.root}${RoutesMap.generativeModel.root}${RoutesMap.generativeModel.settings}`,

	filesRoot: `${Prefixes.root}${Prefixes.files}`,
	filesSettings: `${Prefixes.root}${Prefixes.files}${RoutesMap.files.settings}`,

	editFileRoot: `${Prefixes.root}${Prefixes.editFile}${RoutesMap.editFile.root}`,

	subscriptions: `${Prefixes.root}${RoutesMap.subscriptions}`,

	extensions: `${Prefixes.root}${Prefixes.extensions}`,
	extensionsList: `${Prefixes.root}${Prefixes.extensions}${RoutesMap.extensions.exList}`,
	extensionDetails: `${Prefixes.root}${Prefixes.extensions}/${RoutesMap.extensions.exDetails}`,

	coUsers: `${Prefixes.root}${Prefixes.coUsers}${RoutesMap.coUsers.root}`.slice(0, -1),
	coUsersDetails: `${Prefixes.root}${Prefixes.coUsers}${RoutesMap.coUsers.details}`,

	partners: `${Prefixes.root}${Prefixes.partners}`,
	partnersSettings: `${Prefixes.root}${Prefixes.partners}${RoutesMap.partners.settings}`,
	partnersSettingsWithId: `${Prefixes.root}${Prefixes.partners}${RoutesMap.partners.settingsWithId}`,
	partnersDocumentsWithId: `${Prefixes.root}${Prefixes.partners}${RoutesMap.partners.documentsWithId}`,

	syncSettings: `${Prefixes.root}${Prefixes.syncSettings}`,
	mergeExport: `/merge-export/:id`,

	personalAccount: `${Prefixes.root}${RoutesMap.personalAccount}`,

	integrationsRoot: `${Prefixes.root}${Prefixes.integrations}`,
	// integrationsApiSettings: `${Prefixes.root}${Prefixes.integrations}${RoutesMap.integrations.apiSettings}`,
	integrationsFtpSettings: `${Prefixes.root}${Prefixes.integrations}${RoutesMap.integrations.ftpSettings}`,
	integrationsPublicApiAccess: `${Prefixes.root}${Prefixes.integrations}${RoutesMap.integrations.publicApiAccess}`,

	support: `${Prefixes.root}${RoutesMap.support}`,

	signUp: `${Prefixes.root}${Prefixes.signUp}${RoutesMap.signUp.root}`,
	signUpEmailSend: `${Prefixes.root}${Prefixes.signUp}${RoutesMap.signUp.emailSent}`,
	signUpEmailReceived: `${Prefixes.root}${Prefixes.signUp}${RoutesMap.signUp.emailReceived}`,
	signUpByInvitation: `${Prefixes.root}${Prefixes.signUp}${RoutesMap.signUp.byInvitation}`,
	signIn: `${Prefixes.root}${Prefixes.signIn}${RoutesMap.signIn}`,

	forgotPassword: `${Prefixes.root}${Prefixes.forgotPassword}${RoutesMap.forgotPassword.root}`,
	forgotPasswordSent: `${Prefixes.root}${Prefixes.forgotPassword}${RoutesMap.forgotPassword.emailSent}`,

	createPassword: `${Prefixes.root}${Prefixes.createPassword}${RoutesMap.createPassword.root}`,
	createPasswordLinkExpired: `${Prefixes.root}${Prefixes.createPassword}${RoutesMap.createPassword.linkExpired}`,
	createPasswordSuccess: `${Prefixes.root}${Prefixes.createPassword}${RoutesMap.createPassword.success}`,

	changeEmail: `${Prefixes.root}${Prefixes.changeEmail}${RoutesMap.changeEmail.root}`,
	changeEmailSent: `${Prefixes.root}${Prefixes.changeEmail}${RoutesMap.changeEmail.emailSent}`,

	privacyPolicy: `${Prefixes.root}${RoutesMap.privacyPolicy}`,

	playground: `${Prefixes.root}${RoutesMap.playground}`,

	users: `${Prefixes.root}${Prefixes.users}`.slice(0, -1),
	userDetails: `${Prefixes.root}${Prefixes.users}${RoutesMap.users.details}`,
	resources: `${Prefixes.root}${RoutesMap.resources}`,
};

export const RoleBasedRoutes: Record<
	string,
	{
		path: string;
		link?: string;
		access: Array<(typeof UserRoles)[keyof typeof UserRoles]>;
	}
> = {
	startRecognition: {
		path: Routes.startRecognition,
		access: [UserRoles.user, UserRoles.coUser],
	},
	customModel: {
		path: Routes.customModel,
		access: [UserRoles.user],
	},
	generativeModel: {
		path: Routes.generativeModel,
		access: [UserRoles.user],
	},
	generativeModelUpload: {
		path: Routes.generativeModelUpload,
		access: [UserRoles.user],
	},
	generativeModelSettings: {
		path: Routes.generativeModelSettings,
		access: [UserRoles.user],
	},
	generativeModelFileEditor: {
		path: Routes.generativeModelFileEditor,
		access: [UserRoles.user],
	},
	importCustomFilesRoot: {
		path: Routes.importCustomFilesRoot,
		access: [UserRoles.user],
	},
	customModelSettings: {
		path: Routes.customModelSettings,
		access: [UserRoles.user],
	},
	importCustomFilesDirect: {
		path: '/import-direct-model/:modelId',
		access: [UserRoles.user, UserRoles.coUser],
	},
	importCustomFilesFromFtp: {
		path: '/import-ftp-model/:modelId',
		access: [UserRoles.user, UserRoles.coUser],
	},
	importFilesDirect: {
		path: Routes.importFilesDirect,
		access: [UserRoles.user, UserRoles.coUser],
	},
	importFilesFromFtp: {
		path: Routes.importFilesFromFtp,
		access: [UserRoles.user, UserRoles.coUser],
	},
	filesRoute: {
		path: Routes.filesRoot,
		access: [UserRoles.user, UserRoles.coUser],
	},
	files: {
		path: Routes.filesRoot,
		access: [UserRoles.user, UserRoles.coUser],
	},
	filesSettings: {
		path: Routes.filesSettings,
		access: [UserRoles.user, UserRoles.coUser],
	},
	editModelFile: {
		path: `/edit-model-file/:modelId`,
		access: [UserRoles.user, UserRoles.coUser],
	},
	editFile: {
		path: Routes.editFileRoot,
		access: [UserRoles.user, UserRoles.coUser],
	},
	subscriptions: {
		path: Routes.subscriptions,
		access: [UserRoles.user],
	},
	partners: {
		path: Routes.partners,
		access: [UserRoles.user, UserRoles.coUser],
	},
	partnersSettings: {
		path: Routes.partnersSettings,
		access: [UserRoles.user, UserRoles.coUser],
	},
	partnersDetails: {
		path: Routes.partnersSettingsWithId,
		access: [UserRoles.user, UserRoles.coUser],
	},
	partnersDocumentsWithId: {
		path: Routes.partnersDocumentsWithId,
		access: [UserRoles.user, UserRoles.coUser],
	},
	syncSettings: {
		path: Routes.syncSettings,
		access: [UserRoles.user, UserRoles.coUser],
	},
	extensions: {
		path: Routes.extensions,
		access: [UserRoles.user, UserRoles.coUser],
	},
	extensionsList: {
		path: Routes.extensionsList,
		access: [UserRoles.user],
	},
	extensionDetails: {
		path: Routes.extensionDetails,
		access: [UserRoles.user, UserRoles.coUser],
	},
	coUsers: {
		path: Routes.coUsers,
		access: [UserRoles.user],
	},
	coUsersDetails: {
		path: Routes.coUsersDetails,
		access: [UserRoles.user],
	},
	personalAccount: {
		path: Routes.personalAccount,
		access: [UserRoles.user, UserRoles.coUser, UserRoles.admin],
	},
	// integrationsApiSettings: {
	// 	path: Routes.integrationsApiSettings,
	// 	access: [UserRoles.user, UserRoles.coUser],
	// },
	integrations: {
		path: Routes.integrationsRoot,
		access: [UserRoles.user, UserRoles.coUser],
	},
	integrationsFtpSettings: {
		path: Routes.integrationsFtpSettings,
		access: [UserRoles.user],
	},
	integrationsPublicApiAccess: {
		path: Routes.integrationsPublicApiAccess,
		access: [UserRoles.user],
	},
	support: {
		path: Routes.support,
		access: [UserRoles.user, UserRoles.coUser],
	},
	playground: {
		path: Routes.playground,
		access: [UserRoles.user, UserRoles.coUser],
	},
	users: {
		path: Routes.users,
		access: [UserRoles.admin],
	},
	usersDetails: {
		path: Routes.userDetails,
		access: [UserRoles.admin],
	},
	resources: {
		path: Routes.resources,
		access: [UserRoles.admin],
	},
	mergeExport: {
		path: Routes.mergeExport,
		access: [UserRoles.user, UserRoles.coUser],
	},
	signOut: {
		path: Prefixes.signOut,
		access: [UserRoles.admin, UserRoles.user, UserRoles.coUser],
	},
};
